import _styled from "styled-components";
import { useCallback } from 'react';
import { css } from 'styled-components';
import { SUBTITLE_LINE_HEIGHT_RATIO, subtitleXR } from "../../constants";
import { useHlsContext } from "../../context/Hls";
import { usePlaybackContext } from "../../context/Playback";
import { useResponsiveContext } from "../../context/Responsive";
import { useUIContext } from "../../context/UI";
import { createTextTrackDisplayCss, textTrackCueCss, videoBlockedCss } from "./StyledVideo.styles";
import { jsx as _jsx } from "react/jsx-runtime";
var StyledVideo = function StyledVideo(_ref) {
  var controls = _ref.controls,
    poster = _ref.poster;
  var _useResponsiveContext = useResponsiveContext(),
    playerSize = _useResponsiveContext.playerSize,
    playerHeight = _useResponsiveContext.playerHeight;
  var _usePlaybackContext = usePlaybackContext(),
    autoplay = _usePlaybackContext.autoplay,
    isReady = _usePlaybackContext.isReady,
    videoRef = _usePlaybackContext.videoRef,
    onLoadedMetadata = _usePlaybackContext.onLoadedMetadata,
    onReady = _usePlaybackContext.onReady,
    onPlay = _usePlaybackContext.onPlay,
    onPause = _usePlaybackContext.onPause,
    onEnded = _usePlaybackContext.onEnded,
    onTimeUpdate = _usePlaybackContext.onTimeUpdate,
    onDurationChange = _usePlaybackContext.onDurationChange,
    onSeeking = _usePlaybackContext.onSeeking,
    onLoadStart = _usePlaybackContext.onLoadStart,
    onLoadedData = _usePlaybackContext.onLoadedData,
    currentSource = _usePlaybackContext.currentSource,
    disableSeekForward = _usePlaybackContext.disableSeekForward;
  var currentSourceType = currentSource === null || currentSource === void 0 ? void 0 : currentSource.type;
  var _useHlsContext = useHlsContext(),
    currentQuality = _useHlsContext.currentQuality,
    resetErrorState = _useHlsContext.resetErrorState;
  var currentQualityValue = (currentQuality === null || currentQuality === void 0 ? void 0 : currentQuality.qualityValue) === -1 ? 'auto' : currentQuality === null || currentQuality === void 0 ? void 0 : currentQuality.qualityValue;
  var _useUIContext = useUIContext(),
    visibleUi = _useUIContext.visibleUi;
  var onPlaybackReady = useCallback(function (duration) {
    if (!isReady) {
      onReady({
        duration: duration,
        type: currentSourceType,
        quality: currentQualityValue ? currentQualityValue === null || currentQualityValue === void 0 ? void 0 : currentQualityValue.toString() : undefined
      });
      resetErrorState();
    }
  }, [isReady, onReady, currentSourceType, currentQualityValue, resetErrorState]);
  var onCanPlay = useCallback(function (event) {
    var videoElement = event.target;
    onPlaybackReady(videoElement.duration);
  }, [onPlaybackReady]);
  var onLoadedDataEvent = useCallback(function (event) {
    var videoElement = event.target;

    // 2 means data is available for the current playback position
    if (videoElement.readyState >= 2) {
      onPlaybackReady(videoElement.duration);
    }
    onLoadedData();
  }, [onPlaybackReady, onLoadedData]);
  var onKeyDown = useCallback(function (event) {
    if (disableSeekForward) {
      var keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
      // Permitir: espacio (play/pause), M (mute), F (fullscreen), etc.
      if (keys.includes(event.key)) {
        event.preventDefault();
        event.stopPropagation();
      }
    }
  }, [disableSeekForward]);
  var textTrackDisplayCss = createTextTrackDisplayCss({
    isReady: isReady,
    visibleUi: visibleUi,
    isMd: playerSize.matches.md,
    isSm: playerSize.matches.sm,
    isXs: playerSize.matches.xs
  });
  var subtitleFontSize = subtitleXR[playerSize.valueByHeight] * playerHeight / 100;
  var subtitleLineHeight = subtitleFontSize * SUBTITLE_LINE_HEIGHT_RATIO;
  return /*#__PURE__*/_jsx(_StyledVideo, {
    className: "cp-video absolute inset-0 w-full h-full block z-0",
    ref: videoRef,
    autoPlay: !!autoplay,
    onCanPlay: onCanPlay,
    onLoadedMetadata: onLoadedMetadata,
    onPlay: onPlay,
    onPause: onPause,
    onEnded: onEnded,
    onTimeUpdate: onTimeUpdate,
    onDurationChange: onDurationChange,
    onSeeking: onSeeking,
    onLoadStart: onLoadStart,
    onLoadedData: onLoadedDataEvent,
    onKeyDown: onKeyDown,
    controls: controls,
    poster: poster,
    $_css: disableSeekForward ? videoBlockedCss : '',
    $_css2: textTrackDisplayCss,
    $_css3: subtitleFontSize.toFixed(0),
    $_css4: subtitleLineHeight.toFixed(0)
  });
};
export default StyledVideo;
var _StyledVideo = /*#__PURE__*/_styled("video").withConfig({
  componentId: "sc-16gf4v0-0"
})(["\n        font-family: Poppins, Arial, sans-serif;\n        user-select: none;\n\n        ", "\n\n        ::-webkit-media-text-track-display {\n          ", "\n        }\n        ::cue {\n          ", "\n          font-size: ", "px;\n          line-height: ", "px;\n        }\n      "], function (p) {
  return p.$_css;
}, function (p) {
  return p.$_css2;
}, textTrackCueCss, function (p) {
  return p.$_css3;
}, function (p) {
  return p.$_css4;
});